import {
  CART_ITEM_SOURCE_TYPES,
  CartItemSourceContext,
  Highlight,
  UserProvider,
} from '@vivino/js-web-common';
import {
  RubyLibCartFull,
  RubyLibExploreVintagesPriceRange,
  RubyLibFullRegion,
  RubyLibFullVintage,
  RubyLibFullWine,
  RubyLibMerchantCheckoutPricesAndAvailability,
} from '@webtypes/rubyLibApi';
import React from 'react';
import { VintageProvider } from 'vivino-js/context/VintageContext/VintageContext';
import { HighlightTypes, getFilteredHighlights } from 'vivino-js/helpers/highlights';
import Page from 'vivino-js/utilities/Page/Page';

import MasterWinePage from '@components/MasterWinePage/MasterWinePage';

interface winePageInformationType {
  carts?: RubyLibCartFull[];
  full_region?: RubyLibFullRegion;
  highlights?: Highlight[];
  price_range?: RubyLibExploreVintagesPriceRange;
  prices_and_availabilities?: RubyLibMerchantCheckoutPricesAndAvailability[];
  vintage: RubyLibFullVintage;
  wine: RubyLibFullWine;
  tastes?: any;
}

interface Props {
  user: any;
  countryCode: string;
  stateCode: string;
  translations: Record<string, string>;
  winePageInformation: winePageInformationType;
  promotions: any[];
}

export default ({
  user,
  countryCode,
  stateCode,
  winePageInformation,
  promotions,
  translations,
}: Props) => {
  const wine = winePageInformation.wine;
  const vintage = winePageInformation?.vintage;
  const tastes = winePageInformation?.tastes;
  const pricesAndAvailabilities = winePageInformation?.prices_and_availabilities;
  const priceRange = (winePageInformation.price_range || {}) as RubyLibExploreVintagesPriceRange;

  const highlights = getFilteredHighlights({
    highlights: winePageInformation?.highlights,
    filters: [HighlightTypes.PriceQpr],
  });
  return (
    <Page translations={translations}>
      <UserProvider user={user}>
        <VintageProvider vintage={vintage}>
          <CartItemSourceContext.Provider value={CART_ITEM_SOURCE_TYPES.WINE_PAGE_ROOT}>
            <MasterWinePage
              wine={wine}
              tastes={tastes}
              vintage={vintage}
              stateCode={stateCode}
              priceRange={priceRange}
              highlights={highlights}
              promotions={promotions}
              countryCode={countryCode}
              pricesAndAvailabilities={pricesAndAvailabilities}
            />
          </CartItemSourceContext.Provider>
        </VintageProvider>
      </UserProvider>
    </Page>
  );
};
